module.exports = __webpack_public_path__ + "static/media/wallrus-header-logo.845fe82e.png";